import RequestService from "@/services/request.service";
import { AppError } from "@/services/error.service";
import { clone } from "@/plugins/query";

const GuestsService = {
  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/List%20Guest
  getAll: async function (organizationId, eventId, filters) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/`;
      return await RequestService.get(path, filters);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/Retrieve%20Guest
  get: async function (organizationId, eventId, guestId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/${guestId}/`;
      return await RequestService.get(path);
    } catch (error) {
      throw new AppError(error);
    }
  },

  _prepareGuest: function (data) {
    const obj = clone(data);
    if (obj.group) obj.group = obj.group.id;
    if (obj.partner) obj.partner = obj.partner.id;
    return obj;
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/Create%20Guest
  create: async function (organizationId, eventId, data) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/`;

      return await RequestService.post(path, this._prepareGuest(data));
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/Update%20Guest
  update: async function (organizationId, eventId, data) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/${data.id}/`;
      return await RequestService.put(path, this._prepareGuest(data));
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/v1_organizations_events_guests_destroy
  delete: async function (organizationId, eventId, guestId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/${guestId}/`;
      return await RequestService.delete(path);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/Checkin%20Guest
  checkin: async function (organizationId, eventId, guestId, data) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/${guestId}/checkin/`;
      return await RequestService.post(path, data);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/Deactivate%20Guest
  deactivate: async function (organizationId, eventId, guestId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/${guestId}/deactivate/`;
      return await RequestService.post(path);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/Activate%20Guest
  activate: async function (organizationId, eventId, guestId, data) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/${guestId}/activate/`;
      return await RequestService.post(path, data);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/Export%20Guests
  export: async function (organizationId, eventId, filters = { file_format: "csv" }) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/export/`;
      return await RequestService.getBlob(path, filters);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/Import%20Guests
  import: async function (organizationId, eventId, file) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/import/`;
      return await RequestService.postFile(path, file);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/Generate%20Ticket%20PDF
  getTicketPDF: async function (organizationId, eventId, guestId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/${guestId}/ticket-pdf/`;
      return await RequestService.getBlob(path);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/Generate%20Tickets%20PDF%20for%20all%20guests
  getAllTicketsPDF: async function (organizationId, eventId, filters) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/ticket-pdf/`;
      return await RequestService.getBlob(path, filters);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/Send%20Email
  sendTicket: async function (organizationId, eventId, guestId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/${guestId}/send-email/`;
      return await RequestService.post(path);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guests/Download%20Import%20Template%20CSV%20for%20Guests
  downloadImportTemplate: async function (organizationId, eventId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guests/download-import-template/`;
      return await RequestService.getBlob(path);
    } catch (error) {
      throw new AppError(error);
    }
  },
};

export default GuestsService;
